angular.module('elfium').directive('taskList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'taskListController',
        templateUrl: elfiumUrlService.getTemplateUrl('task', 'taskList')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskList.ts